<template>
  <v-row class="ma-2 justify-center">
    <v-col :cols="isManualKpi ? 3 : undefined">
      <v-card class="text-center" color="green">
        <template v-slot:prepend>
          <v-avatar color="green-lighten-2" size="40">
            <v-icon color="white" size="x-large" icon="mdi-target"></v-icon>
          </v-avatar>
        </template>
        <template v-slot:title>
          <span class="text-body-1 font-weight-medium">
            {{ $t("labels.target-value") }}
          </span>
        </template>
        <template v-slot:subtitle>
          <span class="font-weight-bold">
            {{ targetValue || 0 }}
          </span>
        </template>
      </v-card>
    </v-col>
    <v-col v-if="!isManualKpi">
      <v-card class="text-center" color="deep-orange">
        <template v-slot:prepend>
          <v-avatar color="deep-orange-lighten-2" size="40">
            <v-icon
              color="white"
              size="x-large"
              icon="mdi-trending-down"
            ></v-icon>
          </v-avatar>
        </template>
        <template v-slot:title>
          <span class="text-body-1 font-weight-medium">
            {{ $t("labels.minimum") }}
          </span>
        </template>
        <template v-slot:subtitle>
          <span class="font-weight-bold">
            {{ minimumValue }}
          </span>
        </template>
      </v-card>
    </v-col>
    <v-col v-if="!isManualKpi">
      <v-card class="text-center" color="blue">
        <template v-slot:prepend>
          <v-avatar color="blue-lighten-2" size="40">
            <v-icon
              color="white"
              size="x-large"
              icon="mdi-trending-up"
            ></v-icon>
          </v-avatar>
        </template>
        <template v-slot:title>
          <span class="text-body-1 font-weight-medium">
            {{ $t("labels.maximum") }}
          </span>
        </template>
        <template v-slot:subtitle>
          <span class="font-weight-bold">
            {{ maximumValue }}
          </span>
        </template>
      </v-card>
    </v-col>
    <v-col v-if="!isManualKpi">
      <v-card class="text-center" color="purple">
        <template v-slot:prepend>
          <v-avatar color="purple-lighten-2" size="40">
            <v-icon
              color="white"
              size="x-large"
              icon="mdi-swap-horizontal"
            ></v-icon>
          </v-avatar>
        </template>
        <template v-slot:title>
          <span class="text-body-1 font-weight-medium">
            {{ $t("labels.average") }}
          </span>
        </template>
        <template v-slot:subtitle>
          <span class="font-weight-bold">
            {{ averageValue }}
          </span>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "BadgesDetails",
  props: {
    targetValue: {
      type: [Number, String],
      required: false,
      default: 0,
    },
    statistics: {
      type: Object,
      required: true,
    },
    isManualKpi: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    formatNumber(num) {
      // Convert to a string with up to 6 digits after the decimal
      let str = num.toFixed(6);
      // Remove trailing zeros and the decimal point if there are no fractional digits
      str = str.replace(/\.?0+$/, "");
      return str;
    },
  },
  computed: {
    minimumValue() {
      return this.formatNumber(this.statistics.min) || 0;
    },
    maximumValue() {
      return this.formatNumber(this.statistics.max) || 0;
    },
    averageValue() {
      return this.formatNumber(this.statistics.avg) || 0;
    },
  },
};
</script>
